import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "@/contexts/auth-context";

type PrivateRouteProps = {
  children?: React.ReactNode;
};

const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const { currentUser } = useAuth();
  const location = useLocation();

  return (
    <>
      {currentUser ? (
        children
      ) : (
        <Navigate to={`/login?redirect=${location.pathname}`} />
      )}
    </>
  );
};

export default PrivateRoute;
